import { BaseFieldType } from '../base-field-type';

import { FieldOptions } from './field-options';
import { FieldImageOptions } from './field-image-options';
import { FieldStringOptions } from './field-string-options';
import { FieldNumberOptions } from './field-number-options';
import { FieldProfileOptions } from './field-profile-options';
import { FieldReferenceOptions } from './field-reference-options';

export class FieldOptionsFactory {
    public static create(type: BaseFieldType, options?: Partial<FieldOptions>): FieldOptions | undefined {
        switch (type) {
            case BaseFieldType.FIELD_IMAGE:
                return new FieldImageOptions(options as Partial<FieldImageOptions>);
            case BaseFieldType.FIELD_NUMBER:
                return new FieldNumberOptions(options as Partial<FieldNumberOptions>);
            case BaseFieldType.FIELD_PROFILE:
                return new FieldProfileOptions(options as Partial<FieldProfileOptions>);
            case BaseFieldType.FIELD_REFERENCE:
                return new FieldReferenceOptions(options as Partial<FieldReferenceOptions>);
            case BaseFieldType.FIELD_STRING:
                return new FieldStringOptions(options as Partial<FieldStringOptions>);
        }
        return undefined;
    }
}
